import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VRow, [_c(VCol, {
    staticClass: "pt-3 pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pt-0 pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm.cmOptions.readOnly ? _c('h4', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.jt.rom')))]) : _vm._e(), !_vm.cmOptions.readOnly ? _c('h4', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.jt.em')))]) : _vm._e()]), _c(VCol, {
    staticClass: "pt-0 pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('span', {
    staticClass: "float-right"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-code",
      "disabled": _vm.lcltt != '' || _vm.cloading || _vm.cmOptions.readOnly
    },
    on: {
      "click": _vm.pasteDefault
    }
  })], 1), _c('span', {
    staticClass: "float-right"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": _vm.cmOptions.readOnly ? 'fa-edit' : 'fa-glasses',
      "disabled": _vm.cloading || !_vm.isIotHubManager
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm.cmOptions.readOnly ? _c('span', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.jt.edit')))]) : _vm._e(), !_vm.cmOptions.readOnly ? _c('span', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.jt.check')))]) : _vm._e()])], 1)]), _c(VCol, {
    staticClass: "pt-0 pb-0",
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('p', [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.jt.hint')) + "\n        ")])]), _c(VCol, {
    staticClass: "pt-0 pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('codemirror', {
    ref: "codemirror",
    class: `elevation-1 ${_vm.jsonCheck}`,
    attrs: {
      "options": _vm.cmOptions
    },
    model: {
      value: _vm.lcltt,
      callback: function ($$v) {
        _vm.lcltt = $$v;
      },
      expression: "lcltt"
    }
  })], 1), _c(VCol, {
    staticClass: "pt-4 pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    class: _vm.jsonCheckText
  }, [_vm._v(_vm._s(_vm.jsonMessage))])])], 1)], 1), _c(VCol, {
    staticClass: "pt-3 pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pt-0 pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', [_vm._v("Test-Area")])]), _c(VCol, {
    staticClass: "pt-0 pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('span', {
    staticClass: "float-right"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-running",
      "disabled": _vm.noTesting
    },
    on: {
      "click": _vm.testTrafo
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.jt.test')) + "\n          ")])], 1)]), _c(VCol, {
    staticClass: "pt-0 pb-0",
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": "Test JSON (Demo Data)",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.cloading,
      "hide-details": "auto",
      "name": "testJSON",
      "required": ""
    },
    model: {
      value: _vm.testJSON,
      callback: function ($$v) {
        _vm.testJSON = $$v;
      },
      expression: "testJSON"
    }
  })], 1), _c(VCol, {
    staticClass: "pt-0 pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('codemirror', {
    ref: "codemirror",
    staticClass: "elevation-1",
    attrs: {
      "options": _vm.cmOptions
    },
    model: {
      value: _vm.trafoTestResult,
      callback: function ($$v) {
        _vm.trafoTestResult = $$v;
      },
      expression: "trafoTestResult"
    }
  })], 1), _c(VCol, {
    staticClass: "pt-4 pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm.jsonCheck === 'check-nok' ? _c('p', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.jt.r01')))]) : _vm._e(), !_vm.cmOptions.readOnly ? _c('p', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.jt.r02')))]) : _vm._e(), _vm.cmOptions.readOnly && _vm.jsonCheck === 'check-ok' ? _c('p', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.jt.r03')))]) : _vm._e()])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };